<template>
    <v-app-bar elevation="2" class="border-thin" flat scroll-behavior="hide">

        <v-app-bar-nav-icon variant="text" @click="$emit('toggle-drawer')" v-if="menu && menu.length > 0"></v-app-bar-nav-icon>
        <span v-else class="ml-2 mr-2"></span>
        <!-- Logo / nome -->
        <div class="app-title" @click="naviga({ link: '/' })" style="cursor: pointer;">
            <v-row class="ma-0 pa-0">
                <v-img :src="require('@/assets/logo.png')" width="32" height="32" class="mr-2" />
                <span class="font-weight-semibold mt-0" style="font-size: 1.2em;">Rilievi Misure</span>
            </v-row>
        </div>

        <v-spacer />

        <!-- Menu utente -->
        <v-menu transition="slide-y-transition">

            <template #activator="{ props }">
                <v-btn icon v-bind="props">
                    <v-icon size="x-large">mdi-account-circle</v-icon>
                </v-btn>
            </template>

            <v-card min-width="220">
                <v-list>
                    <v-list-item>
                        <template #prepend>
                            <v-icon size="x-large">mdi-account-circle</v-icon>
                        </template>
                        <v-list-item-title>
                            {{ utente }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ mail }}
                        </v-list-item-subtitle>
                    </v-list-item>
                </v-list>

                <v-divider />

                <v-list density="compact">

                    <v-list-item prepend-icon="mdi-account-cog" @click="profilo()">
                        <v-list-item-title>
                            Profilo
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item prepend-icon="mdi-logout" @click="esci()">
                        <v-list-item-title>
                            Esci
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
    </v-app-bar>
</template>

<script>

import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";

export default {
    name: "ToolBarComponent",
    props: {
        utente: { type: String, default: "" },
        mail: { type: String, default: "" },
        menu: { type: Array, default: () => [] },
    },
    emits: ["esci", "toggle-drawer"],

    setup(_, { emit }) {
        const router = useRouter();
        const route = useRoute();

        const disabilitaBtn = ref(false);

        const esci = () => {
            disabilitaBtn.value = true;
            emit("esci");
        };

        const profilo = () => {
            router.push({ path: "/profilo" });
        };

        function naviga(item) {
            disabilitaBtn.value = true;
            if (item.link.startsWith("/")) {
                router.push({ path: item.link });
            } else if (item.link == "@esci")
                emit("esci");
            disabilitaBtn.value = false;
        }

        function isActive(link) {
            return route.path === link || route.path.startsWith(link + "/");
        }

        return {
            disabilitaBtn,
            esci,
            profilo,
            naviga,
            isActive,
        };
    },
};
</script>